import { useState } from 'react';
import {
  ArrowRight,
  Briefcase,
  Calendar,
  CalendarCheck,
  CheckCircle2,
  FileText,
  GraduationCap,
  Globe,
  Mic,
  Presentation,
  Sparkles,
  Star,
  Users
} from 'lucide-react';
import { Link } from 'react-router-dom';
import heroImage from '../assets/acceuil4.jpg';
import ordi from '../assets/ordi.png';
import sparksProjectLogo from '../assets/sparks-project-logo-new.png';
import wellnessFamilyLogo from '../assets/wellness-family-logo.png';
import gofarHoldingLogo from '../assets/gofar-holding-logo.png';


// ===== Chemins publics vers /public/assets/ =====
const academieMCE = '/assets/Académie_MCE.jpg';
const accompagnementRH = '/assets/accompagnementRH.png';
const accompagnementEvenements = '/assets/ACCOMPAGNEMENT_ÉVÉNEMENTS.jpg';
const caireproLogo = '/assets/cairepro.png';
const naboopayLogo = '/assets/naboopay.png';

// ===== Logos agréments & certifications =====
const sonatelLogo = '/assets/orange.png';
const googleLogo = '/assets/google.png';
const googleGLogo = '/assets/google-g.png';
const iaLogo = '/assets/IA.png';
const claudeLogo = '/assets/Claude.png';
const n8nLogo = '/assets/n8n.svg';

// ===== Nouveaux partenaires =====
const marimikaLogo = '/assets/marimika.png';
const nayaHarmonieLogo = '/assets/NayaHarmonie.png';
const immobilierLogo = '/assets/immobilier.png';
const baPartnersLogo = '/assets/bapartenaers.png';
const corporateVisionLogo = '/assets/coorporatevision.png';
const hashHouseHarriersLogo = '/assets/HHH.jpeg';

// ===== Partenaires institutionnels, financiers & tech (ajout) =====
const artpLogo = '/assets/artp.svg';
const corisBankLogo = '/assets/coris-bank.svg';
const fonsisLogo = '/assets/fonsis.png';
const vigilusLogo = '/assets/vigilus.png';
const bforProcessLogo = '/assets/bforprocess.png';
const licanamLogo = '/assets/licanam.png';
const tellyTechLogo = '/assets/telly-tech.png';

// ===== Données partenaires =====
const partners = [
  {
    logo: '/assets/nabeny-immobilier.png',
    alt: 'Logo Nabeny — NB Immobilier',
    name: 'Nabeny',
    tagline: 'France, Sénégal & Maroc — Opportunités sans frontières - Marrakech',
    desc: '« Unir nos réseaux et nos savoir-faire pour connecter les talents, les projets et les investisseurs entre la France, le Sénégal et le Maroc. »',
    quote: true,
    logoSize: 'large',
    url: 'https://www.nabeny.co/',
  },
  {
    logo: caireproLogo,
    alt: 'Logo CAIREPRO',
    name: 'CAIREPRO',
    tagline: 'Architecture & ingénierie - Italie',
    desc: '« L’expertise italienne au service de projets architecturaux, urbains et techniques à dimension internationale. »',
    quote: true,
    logoSize: 'default',
    url: 'https://www.cairepro.it/',
  },
  {
    logo: sparksProjectLogo,
    alt: 'Logo Sparck Projects',
    name: 'Sparck Projects',
    tagline: 'Financement & éducation financière - Dakar',
    desc: '« Faire passer les projets de l’idée à une trajectoire de financement structurée. »',
    quote: true,
    logoSize: 'large',
    url: 'https://sparks-project.com/',
  },
  {
    logo: naboopayLogo,
    alt: 'Logo NabooPay',
    name: 'NabooPay',
    tagline: 'Paiements digitaux & e-commerce - Dakar',
    desc: '« Des solutions de paiement pensées pour fluidifier le commerce digital entre l’Europe et l’Afrique. »',
    quote: true,
    logoSize: 'default',
    url: 'https://naboopay.com/',
  },
  {
    logo: gofarHoldingLogo,
    alt: 'Logo GOFAR Foundation',
    name: 'GOFAR Holding',
    tagline: 'Impact, inclusion & entrepreneuriat - Dakar',
    desc: '« Encourager l’autonomie économique et faire émerger des projets à impact. »',
    quote: true,
    logoSize: 'large',
    url: 'https://gofarc.com/',
  },
  {
    logo: hashHouseHarriersLogo,
    alt: 'Logo Hash House Harriers Dakar',
    name: 'Hash House Harriers Dakar',
    tagline: 'Sport, convivialité & esprit de groupe - Dakar',
    desc: '« Courir, marcher, découvrir Dakar et créer du lien dans un esprit sportif et convivial. »',
    quote: true,
    logoSize: 'large',
    url: 'https://www.facebook.com/hash.dakar/?locale=fr_FR',
  },
  {
    logo: immobilierLogo,
    alt: 'Logo Le Souk de l’Immobilier',
    name: 'Le Souk de l’Immobilier',
    tagline: 'Immobilier - Marrakech',
    desc: '« Investir, s’installer ou développer un projet immobilier à Marrakech avec un accompagnement de proximité. »',
    quote: true,
    logoSize: 'large',
    url: 'https://www.facebook.com/groups/lesoukdelimmobiliermarrakech/?locale=fr_FR',
  },
  {
    logo: nayaHarmonieLogo,
    alt: 'Logo Naya Harmonie',
    name: 'Naya Harmonie',
    tagline: 'Bien-être féminin - Paris',
    desc: '« Prendre soin des femmes à chaque étape de leur vie, pour mieux concilier équilibre personnel et ambition professionnelle. »',
    quote: true,
    logoSize: 'default',
    url: 'https://nayaharmonie.com/',
  },
  {
    logo: corporateVisionLogo,
    alt: 'Logo Corporate Vision',
    name: 'Corporate Vision',
    tagline: 'Expert Comptable - Paris',
    desc: '« Donner aux entreprises une lecture claire de leurs chiffres pour décider, structurer et grandir. »',
    quote: true,
    logoSize: 'default',
    url: 'https://www.corporatevision.fr/',
  },
  {
    logo: marimikaLogo,
    alt: 'Logo Marimika',
    name: 'Marimika',
    tagline: 'Mode & sportswear sans frontières - Paris, Dakar',
    desc: '« Une mode en mouvement, pensée pour relier les cultures et affirmer les identités. »',
    quote: true,
    logoSize: 'default',
    url: 'https://marimika.com/',
  },
  {
    logo: '/assets/2Aservices.png',
    alt: 'Logo 2AServices',
    name: '2AServices',
    tagline: 'Architecture, bâtiment & construction - Dakar',
    desc: '« De la conception à la réalisation, donner vie à des projets solides, durables et pensés dans les moindres détails. »',
    quote: true,
    logoSize: 'default',
    url: 'https://2aservices-sn.com/',
  },
  {
    logo: '/assets/masslocation.jpeg',
    alt: 'Logo Mass Location Voitures',
    name: 'Mass Location Voitures',
    tagline: 'Location de véhicules & services touristiques - Dakar',
    desc: '« Faciliter chaque déplacement avec des solutions de mobilité adaptées, fiables et pensées pour les besoins de chaque client. »',
    quote: true,
    logoSize: 'default',
    url: 'https://masslocation.com/',
  },

  // ===== Nouveaux partenaires (ajout) =====
  {
    logo: artpLogo,
    alt: 'Logo ARTP — Autorité de Régulation des Télécommunications et des Postes',
    name: 'ARTP',
    tagline: 'Régulation des télécoms & des postes - Dakar',
    desc: '« Garantir un écosystème numérique ouvert, fiable et accessible, au service de la transformation digitale du Sénégal. »',
    quote: true,
    logoSize: 'default',
    url: 'https://artp.sn/',
  },
  {
    logo: corisBankLogo,
    alt: 'Logo Coris Bank International Sénégal',
    name: 'Coris Bank',
    tagline: 'Banque & services financiers - Dakar',
    desc: '« Accompagner les entreprises et les particuliers avec des solutions bancaires proches de leurs ambitions. »',
    quote: true,
    logoSize: 'default',
    url: 'https://senegal.coris.bank/',
  },
  {
    logo: fonsisLogo,
    alt: 'Logo FONSIS — Fonds Souverain d’Investissements Stratégiques',
    name: 'FONSIS',
    tagline: 'Fonds souverain d’investissements stratégiques - Dakar',
    desc: '« Investir dans les secteurs stratégiques pour soutenir une croissance durable et créatrice de valeur au Sénégal. »',
    quote: true,
    logoSize: 'default',
    url: 'https://www.fonsis.org/fr/',
  },
  {
    logo: vigilusLogo,
    alt: 'Logo Vigilus Facilities',
    name: 'Vigilus',
    tagline: 'Facility management & services aux entreprises - Dakar',
    desc: '« Assurer des environnements de travail sûrs, propres et bien gérés, pour que chaque entreprise se concentre sur l’essentiel. »',
    quote: true,
    logoSize: 'default',
    url: 'https://vigilus-facilities.com/',
  },
  {
    logo: sonatelLogo,
    alt: 'Logo Sonatel',
    name: 'Sonatel',
    tagline: 'Télécommunications & services numériques - Dakar',
    desc: '« Connecter les personnes et les entreprises pour accélérer l’inclusion et l’innovation numérique en Afrique de l’Ouest. »',
    quote: true,
    logoSize: 'default',
    url: 'https://sonatel.sn/',
  },
  {
    logo: bforProcessLogo,
    alt: 'Logo BforProcess',
    name: 'BforProcess',
    tagline: 'Processus métiers & transformation digitale',
    desc: '« Structurer et optimiser les processus pour rendre les organisations plus agiles et plus performantes. »',
    quote: true,
    logoSize: 'default',
    url: 'http://bforprocess.com/',
  },
  {
    logo: licanamLogo,
    alt: 'Logo Licanam',
    name: 'Licanam',
    tagline: 'Solutions & services aux entreprises',
    desc: '« Apporter des réponses concrètes et sur mesure aux enjeux de développement des entreprises. »',
    quote: true,
    logoSize: 'default',
    url: 'https://licanam.com/',
  },
  {
    logo: tellyTechLogo,
    alt: 'Logo Telly Tech',
    name: 'Telly Tech',
    tagline: 'Solutions technologiques & digitales',
    desc: '« Mettre la technologie au service de la croissance, avec des solutions innovantes et adaptées au terrain. »',
    quote: true,
    logoSize: 'default',
    url: 'https://telly-tech.com/',
  },
];

// ===== Données défis =====
const defis = [
  { icon: Users, title: 'Networking', sub: 'professionnel' },
  { icon: Presentation, title: 'Séminaires', sub: 'd’entreprise' },
  { icon: GraduationCap, title: 'Ateliers &', sub: 'formations' },
  { icon: Mic, title: 'Conférences &', sub: 'panels' },
  { icon: CalendarCheck, title: 'Événements', sub: 'sur mesure' },
];

// ===== Données certifications =====
const certifications = [
  {
    logo: sonatelLogo,
    alt: 'Sonatel',
    title: 'Agréé Sonatel',
    year: '2025',
    logoClass: 'h-12 sm:h-16 lg:h-20',
  },
  {
    logo: googleLogo,
    alt: 'Google',
    title: 'Certifié Google',
    year: '2025',
    logoClass: 'h-16 sm:h-20 lg:h-24',
  },
  {
    logo: iaLogo,
    alt: 'Intelligence Artificielle',
    title: 'Certifié en\nIntelligence Artificielle',
    year: '2025',
    logoClass: 'h-10 sm:h-14 lg:h-18',
    special: true,
  },
  {
    logos: [
      { src: claudeLogo, alt: 'Claude', class: 'h-5 sm:h-7 lg:h-9' },
      { src: n8nLogo, alt: 'n8n', class: 'h-5 sm:h-7 lg:h-9' },
      { src: googleGLogo, alt: 'Google', class: 'h-5 sm:h-7 lg:h-9' },
    ],
    title: 'Expertise en automatisation\n& solutions IA',
    year: '2025',
  },
];

export default function Home() {
  // Pause du défilement auto pendant que le doigt/souris interagit
  const [isInteracting, setIsInteracting] = useState(false);

  return (
    <div className="pt-[72px]">
      {/* ===================== HERO DESKTOP ===================== */}
      <section
        className="hidden lg:block relative overflow-hidden"
        style={{ backgroundColor: '#ffffff', minHeight: '620px' }}
      >
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url(${heroImage})`,
            backgroundSize: 'cover',
            backgroundPosition: '90% center',
            backgroundRepeat: 'no-repeat',
          }}
        />

        <div
          className="absolute inset-0"
          style={{
            background:
              'linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 42%, rgba(255,255,255,0.6) 52%, rgba(255,255,255,0) 65%)',
          }}
        />

        <div className="relative max-w-[1400px] mx-auto pl-10 pr-10 pt-14 pb-20 grid grid-cols-12 gap-10 items-center">
          <div className="col-span-5">
            <h1
              className="mt-6 text-[34px] font-black leading-[1.15] tracking-tight"
              style={{ color: '#001a3d' }}
            >
              Vos ambitions n’ont pas de frontières,{' '}
              <span style={{ color: '#0099CC' }}>notre engagement non plus.</span>
            </h1>

            <p
              className="mt-5 text-[15px] leading-relaxed max-w-2xl"
              style={{ color: '#001a3d', opacity: 0.8 }}
            >
              Une équipe experte à Dakar, des partenaires en France, au Maroc et en Italie, pour faire avancer vos projets avec exigence, proximité et vision internationale.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              <Link
                to="/accompagnement-evenements/evenementiel"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md transition-all font-bold text-[13px] tracking-wide shadow-lg hover:shadow-xl hover:-translate-y-0.5"
                style={{ backgroundColor: '#001a3d', color: '#ffffff' }}
              >
                <FileText className="w-4 h-4" style={{ color: '#0099CC' }} />
                Nos événements
              </Link>
              <Link
                to="/contact#contact-form"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md transition-all font-bold text-[13px] tracking-wide border-2 shadow-md hover:shadow-lg hover:-translate-y-0.5"
                style={{
                  backgroundColor: 'rgba(255,255,255,0.95)',
                  borderColor: '#001a3d',
                  color: '#001a3d',
                }}
              >
                <Calendar className="w-4 h-4" style={{ color: '#0099CC' }} />
                Prendre rendez-vous
              </Link>
            </div>
          </div>

          <div className="col-span-7 relative min-h-[500px]" />
        </div>

        <div className="relative">
          <svg viewBox="0 0 1440 40" className="w-full h-10" preserveAspectRatio="none">
            <path d="M0,20 Q360,0 720,20 T1440,20 L1440,40 L0,40 Z" fill="#d4a017" />
          </svg>
        </div>
      </section>

      {/* ===================== HERO MOBILE ===================== */}
      <section
        className="lg:hidden overflow-hidden"
        style={{ background: 'linear-gradient(180deg, #f5faff 0%, #ffffff 100%)' }}
      >
        <div className="px-6 pt-10 pb-2 flex flex-col items-center text-center">
          <h1
            className="font-black leading-[1.2] tracking-[-0.02em] text-[clamp(1.35rem,5vw,2rem)]"
            style={{ color: '#001a3d' }}
          >
            L&rsquo;expertise digitale, humaine et{' '}
            <span style={{ color: '#0099CC' }}>événementielle au service de votre stratégie.</span>
          </h1>

          <div className="mt-4 h-[3px] w-12 rounded-full" style={{ backgroundColor: '#0099CC' }} />

          <p
            className="mt-5 max-w-[520px] text-[clamp(0.9rem,2.8vw,1.05rem)] leading-[1.6]"
            style={{ color: 'rgba(0,26,61,0.78)' }}
          >
            Partenaire des PME, ETI et grandes structures en France, MCE sécurise et accélère
            vos initiatives nationales et vos synergies avec le Maroc et le Sénégal.
          </p>
        </div>

        <div className="mt-6 w-full h-[clamp(300px,58vw,520px)]">
          <div
            className="h-full w-full overflow-hidden"
            style={{
              clipPath: 'ellipse(90% 100% at 50% 100%)',
              WebkitClipPath: 'ellipse(90% 100% at 50% 100%)',
            }}
          >
            <img
              src={heroImage}
              alt="Partenariat MCE"
              className="h-full w-full object-cover"
              style={{ objectPosition: 'center center' }}
            />
          </div>
        </div>

        <div className="bg-white px-5 pt-5 pb-8 space-y-3">
          <Link
            to="/accompagnement-evenements/evenementiel"
            className="group flex min-h-[52px] w-full items-center gap-3 rounded-lg px-4 shadow-[0_4px_14px_rgba(0,26,61,0.12)] transition-all active:scale-[0.99]"
            style={{ backgroundColor: '#001a3d', color: '#ffffff' }}
          >
            <Calendar className="h-5 w-5 shrink-0" style={{ color: '#00A8E8' }} />
            <span className="flex-1 text-left text-[15px] font-bold">Nos événements</span>
            <ArrowRight className="h-5 w-5 shrink-0 transition-transform group-hover:translate-x-1" />
          </Link>

          <Link
            to="/contact#contact-form"
            className="group flex min-h-[52px] w-full items-center gap-3 rounded-lg border-2 bg-white px-4 transition-all active:scale-[0.99]"
            style={{ borderColor: '#001a3d', color: '#001a3d' }}
          >
            <Calendar className="h-5 w-5 shrink-0" style={{ color: '#00A8E8' }} />
            <span className="flex-1 text-left text-[15px] font-bold">Prendre rendez-vous</span>
            <ArrowRight className="h-5 w-5 shrink-0 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
      </section>

      {/* ===================== VOS DÉFIS / EXPERTISES ===================== */}
      <section className="relative bg-white border-b border-gray-100 overflow-hidden">
        <div
          className="absolute inset-y-0 right-0 w-1/2 pointer-events-none hidden md:block"
          style={{
            opacity: 0.08,
            backgroundImage: `radial-gradient(circle at 20% 30%, #0099CC 1px, transparent 1.5px),
                              radial-gradient(circle at 40% 50%, #0099CC 1px, transparent 1.5px),
                              radial-gradient(circle at 60% 20%, #0099CC 1px, transparent 1.5px),
                              radial-gradient(circle at 75% 45%, #0099CC 1px, transparent 1.5px),
                              radial-gradient(circle at 55% 70%, #0099CC 1px, transparent 1.5px),
                              radial-gradient(circle at 80% 75%, #0099CC 1px, transparent 1.5px),
                              radial-gradient(circle at 30% 80%, #0099CC 1px, transparent 1.5px)`,
            backgroundSize: '20px 20px',
          }}
        />

        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 py-12 lg:py-16">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="h-px w-14" style={{ backgroundColor: '#d4a017' }} />
            <div
              className="w-12 h-12 rounded-full flex items-center justify-center"
              style={{ backgroundColor: '#fef3c7' }}
            >
              <Sparkles className="w-6 h-6" style={{ color: '#d4a017' }} />
            </div>
            <div className="h-px w-14" style={{ backgroundColor: '#d4a017' }} />
          </div>

          <div className="text-center mb-3">
            <h2
              className="text-2xl md:text-3xl lg:text-[38px] font-black leading-tight"
              style={{ color: '#001a3d' }}
            >
              Vos défis d&rsquo;aujourd&rsquo;hui
            </h2>
            <h3
              className="text-2xl md:text-3xl lg:text-[38px] font-black leading-tight mt-1"
              style={{ color: '#0099CC' }}
            >
              sont nos missions quotidiennes.
            </h3>
          </div>

          <div
            className="h-1 w-16 mx-auto rounded-full mb-6"
            style={{ backgroundColor: '#d4a017' }}
          />

          <div className="text-center max-w-4xl mx-auto mb-10 space-y-3">
            <p
              className="text-[14px] lg:text-[15px] leading-relaxed"
              style={{ color: '#001a3d', opacity: 0.85 }}
            >
              MCE France accompagne les entreprises, institutions et porteurs de projets avec une expertise
              digitale, humaine et internationale.
            </p>
            <p
              className="text-[14px] lg:text-[15px] leading-relaxed"
              style={{ color: '#001a3d', opacity: 0.85 }}
            >
              Une équipe opérationnelle à Dakar, des partenaires stratégiques en France, au Maroc, en Italie
              et en Afrique de l&rsquo;Ouest, pour concevoir et piloter des projets ambitieux sans frontières.
            </p>
          </div>

          {/* Cartes défis */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
            {defis.map((d, i) => (
              <div
                key={i}
                className="flex items-center gap-4 p-4 lg:p-5 rounded-xl shadow-md hover:shadow-xl hover:-translate-y-0.5 transition-all"
                style={{ backgroundColor: '#001a3d' }}
              >
                <div
                  className="w-12 h-12 lg:w-14 lg:h-14 rounded-full shrink-0 flex items-center justify-center"
                  style={{ backgroundColor: 'rgba(0, 153, 204, 0.15)' }}
                >
                  <d.icon className="w-6 h-6 lg:w-7 lg:h-7" style={{ color: '#0099CC' }} />
                </div>
                <div className="text-white leading-tight">
                  <div className="text-[14px] lg:text-[15px] font-bold">{d.title}</div>
                  <div className="text-[14px] lg:text-[15px] font-bold">{d.sub}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===================== 3 UNIVERS ===================== */}
      <section className="py-20 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <h2 className="section-title mt-3 text-center">Trois expertises, un seul objectif : votre réussite.</h2>
          <div className="h-1 w-16 mx-auto rounded-full mt-3 mb-12" style={{ backgroundColor: '#0099CC' }} />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              {
                title: 'SOLUTIONS DIGITALES',
                sub: 'Solutions CRM, SaaS et de gestion pour votre transformation numérique.',
                img: academieMCE,
                titleColor: 'text-mce-navy',
                btn: 'bg-mce-navy hover:bg-mce-navy/90 text-white',
                cta: 'SOLUTIONS DIGITALES',
                items: ['Automatisation des tâches', 'Sauvegardes sécurisées', 'Analytique avancée'],
                to: '/solutions-digitales',
              },
              {
                title: 'TALENTS & RH',
                sub: 'Développer les talents. Renforcer les équipes. Booster la performance.',
                img: accompagnementRH,
                titleColor: 'text-black',
                btn: 'text-black transition-colors',
                cta: 'DÉVELOPPER VOS TALENTS',
                items: ['Formations certifiantes', 'Recrutement ciblé', 'Coaching & Management'],
                to: '/talents-rh',
              },
              {
                title: 'ACCOMPAGNEMENT & ÉVÉNEMENTS',
                sub: 'Vous accompagner à chaque étape. Créer des connexions impactantes.',
                img: accompagnementEvenements,
                titleColor: 'text-mce-navy',
                btn: 'bg-mce-navy hover:bg-mce-navy/90 text-white',
                cta: "CRÉER DE L'IMPACT",
                items: ['Accompagnement stratégique', 'Conférences & Séminaires', 'Réseautage professionnel'],
                to: '/accompagnement-evenements',
              },
            ].map((u, i) => (
              <div
                key={i}
                className="rounded-2xl bg-white border border-gray-100 shadow-md overflow-hidden card-hover flex flex-col p-6"
              >
                <div className="relative h-[180px] rounded-xl overflow-hidden mb-5">
                  <img src={u.img} alt={u.title} className="absolute inset-0 w-full h-full object-cover" />
                </div>
                <div className="flex-1 flex flex-col text-center">
                  <h3 className={`font-black text-[20px] leading-tight ${u.titleColor} whitespace-pre-line`}>
                    {u.title}
                  </h3>
                  <p className="text-[14px] text-mce-navy/75 mt-3 leading-relaxed">{u.sub}</p>
                  <ul className="mt-5 space-y-2.5 flex-1 text-left inline-block mx-auto">
                    {u.items.map((it) => (
                      <li key={it} className="flex items-start gap-2 text-[14px] text-mce-navy/85">
                        <CheckCircle2 className="w-4 h-4 mt-0.5 shrink-0" style={{ color: '#0099CC' }} />
                        {it}
                      </li>
                    ))}
                  </ul>
                  <Link
                    to={u.to}
                    className={`mt-6 text-[13px] font-bold py-3.5 rounded-md ${u.btn} inline-flex items-center justify-center gap-2 tracking-wide w-full`}
                    style={i === 1 ? { backgroundColor: '#0099CC' } : {}}
                  >
                    {u.cta}
                  </Link>
                </div>
              </div>
            ))}
          </div>

          {/* SAAS BANNER */}
          <div className="mt-16 rounded-2xl bg-mce-navy text-white p-6 md:p-10 grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 items-center overflow-hidden relative shadow-xl">
            <div className="md:col-span-4 flex items-center justify-center">
              <div className="relative w-full max-w-sm">
                <img src={ordi} alt="Digital Network" className="w-full h-auto object-contain" />
              </div>
            </div>

            <div className="md:col-span-5 text-left">
              <h3 className="hidden md:block text-3xl md:text-4xl font-black leading-tight text-white">
                PRENEZ UNE <span style={{ color: '#0099CC' }}>LONGUEUR D'AVANCE.</span>
              </h3>
              <h3 className="md:hidden font-black leading-tight text-white text-[clamp(1.05rem,4.4vw,1.5rem)] whitespace-nowrap">
                PRENEZ UNE <span style={{ color: '#0099CC' }}>LONGUEUR D'AVANCE.</span>
              </h3>

              <p className="hidden md:block text-white/90 text-[15px] mt-5 leading-relaxed">
                CRM, plateformes, applications métiers, tableaux de bord... Nos solutions SaaS et personnalisées simplifient vos processus, améliorent votre productivité et accélèrent votre croissance.
              </p>
              <p className="md:hidden text-white/90 text-[13.5px] mt-4 leading-relaxed">
                Nos solutions SaaS simplifient vos processus et accélèrent votre croissance.
              </p>
            </div>

            <div className="md:col-span-3 text-left space-y-3">
              <ul className="space-y-3">
                {[
                  'Automatisation des tâches',
                  'Gestion de la relation client',
                  'Analytique de données',
                  'Décisions basées sur la donnée',
                  'Sécurité des tâches',
                  'Hébergement de confiance',
                ].map((it) => (
                  <li key={it} className="flex items-start gap-2.5 text-[14px]">
                    <CheckCircle2 className="w-5 h-5 mt-0.5 shrink-0" style={{ color: '#0099CC' }} /> {it}
                  </li>
                ))}
              </ul>
              <Link
                to="/solutions-digitales"
                className="home-saas-cta mt-6 inline-flex items-center gap-2 text-white text-[13px] font-bold py-3.5 px-6 rounded-md transition-colors w-full justify-center shadow-lg"
                style={{ backgroundColor: '#0099CC' }}
              >
                DÉCOUVRIR NOS SOLUTIONS SAAS
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ===================== MCE EN CHIFFRES ===================== */}
      <section className="py-12 lg:pb-16 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <h2 className="section-title mt-3 text-center">MCE en chiffres.</h2>
          <div className="h-1 w-16 mx-auto rounded-full mt-3 mb-8" style={{ backgroundColor: '#0099CC' }} />

          <div className="hidden md:grid rounded-2xl bg-white shadow-md border border-gray-100 px-8 py-8 grid-cols-4 gap-8">
            {[
              { icon: Briefcase, color: '#0099CC', value: "+25 ans", label: "D'expérience en", sub: "ressources humaines" },
              { icon: GraduationCap, color: '#9333ea', value: "+50", label: "Projets réalisés", sub: "par année" },
              { icon: Globe, color: '#0099CC', value: "3", label: "Pays d'implantation", sub: "France · Sénégal · Maroc" },
              { icon: Star, color: '#d4a017', value: "+95%", label: "De clients satisfaits", sub: "et recommandant MCE" },
            ].map((s, i) => (
              <div key={i} className="flex flex-col items-center text-center gap-2">
                <s.icon className="w-8 h-8" style={{ color: s.color }} />
                <span className="text-2xl font-black text-mce-navy">{s.value}</span>
                <div className="text-[13px] font-medium text-mce-navy/80 leading-tight">
                  <div>{s.label}</div>
                  <div className="opacity-75">{s.sub}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="md:hidden grid grid-cols-2 gap-4">
            {[
              { icon: Briefcase, color: '#0099CC', value: "+25 ans", label: "D'expérience en\nressources humaines" },
              { icon: GraduationCap, color: '#0099CC', value: "+50", label: "Projets réalisés\npar année" },
              { icon: Globe, color: '#0099CC', value: "3", label: "Pays d'implantation\nFrance · Sénégal · Maroc" },
              { icon: Star, color: '#d4a017', value: "+95%", label: "De clients satisfaits\net recommandant MCE" },
            ].map((s, i) => (
              <div key={i} className="flex flex-col items-center gap-2 p-3">
                <s.icon className="w-6 h-6" style={{ color: s.color }} />
                <div className="text-center">
                  <div className="font-black text-base text-mce-navy">{s.value}</div>
                  <div className="text-[11px] text-mce-navy/70 leading-snug whitespace-pre-line">
                    {s.label}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===================== AGRÉMENTS & CERTIFICATIONS (MÉDAILLONS) ===================== */}
      <section
        className="py-16 lg:py-20"
        style={{ background: 'linear-gradient(180deg, #e6f5fb 0%, #d4ecf7 100%)' }}
      >
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <h2
            className="text-2xl md:text-3xl lg:text-[36px] font-black text-center leading-tight"
            style={{ color: '#001a3d' }}
          >
            Agréments et certifications
          </h2>
          <div
            className="h-[3px] w-20 mx-auto rounded-full mt-4 mb-14"
            style={{ backgroundColor: '#001a3d' }}
          />

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6 lg:gap-6 place-items-center">
            {certifications.map((c, i) => (
              <div
                key={i}
                className="relative w-full max-w-[200px] sm:max-w-[240px] lg:max-w-[260px] aspect-square rounded-full flex flex-col items-center justify-center px-4 sm:px-5 lg:px-6 py-4 transition-all hover:scale-105"
                style={{
                  background: 'radial-gradient(circle at 30% 30%, #ffffff 0%, #f4faff 70%, #e6f5fb 100%)',
                  boxShadow:
                    '0 8px 24px rgba(0, 26, 61, 0.12), inset 0 -3px 6px rgba(0, 26, 61, 0.05), inset 0 3px 6px rgba(255, 255, 255, 0.9)',
                  border: '1px solid rgba(255,255,255,0.9)',
                }}
              >
                {/* Logo(s) */}
                <div className="flex items-center justify-center gap-1.5 sm:gap-2 lg:gap-3 mb-2 lg:mb-3 min-h-[50px] sm:min-h-[65px] lg:min-h-[80px] max-w-full">
                  {c.logos ? (
                    c.logos.map((l, j) => (
                      <img
                        key={j}
                        src={l.src}
                        alt={l.alt}
                        className={`${l.class} object-contain max-w-[28%]`}
                      />
                    ))
                  ) : (
                    <img
                      src={c.logo}
                      alt={c.alt}
                      className={`${c.logoClass} object-contain max-w-[75%]`}
                    />
                  )}
                </div>

                {/* Titre */}
                <p
                  className="text-[10px] sm:text-[11px] lg:text-[13px] text-center font-bold leading-tight whitespace-pre-line px-1 mb-6 sm:mb-8"
                  style={{ color: '#001a3d' }}
                >
                  {c.title}
                </p>

                {/* Sceau année */}
                <div
                  className="absolute bottom-2 sm:bottom-3 flex items-center justify-center w-8 h-8 sm:w-9 sm:h-9 rounded-full"
                  style={{
                    background: 'radial-gradient(circle at 30% 30%, #fef3c7 0%, #d4a017 100%)',
                    boxShadow: '0 2px 4px rgba(212, 160, 23, 0.4)',
                  }}
                >
                  <span className="text-[8px] sm:text-[9px] font-black text-white">{c.year}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===================== PARTENAIRES (MARQUEE + SWIPE) ===================== */}
      <section
        className="pb-20 pt-10 w-full overflow-hidden"
        style={{ background: 'linear-gradient(180deg, #f5faff 0%, #ffffff 100%)' }}
      >
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="h-px w-14" style={{ backgroundColor: '#d4a017' }} />
            <div className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: '#d4a017' }} />
            <div className="h-px w-14" style={{ backgroundColor: '#d4a017' }} />
          </div>

          <h2
            className="text-3xl md:text-4xl lg:text-[42px] font-black text-center leading-tight"
            style={{ color: '#001a3d' }}
          >
            Nos partenaires stratégiques
          </h2>

          <p
            className="text-center max-w-3xl mx-auto mt-5 text-[14px] lg:text-[15px] leading-relaxed"
            style={{ color: '#001a3d', opacity: 0.8 }}
          >
            Un réseau de partenaires de confiance pour accompagner des projets ambitieux
            <br className="hidden md:block" />
            en France, au Sénégal, au Maroc, en Italie et en Afrique de l&rsquo;Ouest.
          </p>

          <p className="text-center text-[12px] mt-3 md:hidden" style={{ color: '#0099CC', opacity: 0.85 }}>
            ← Faites glisser pour explorer →
          </p>
        </div>

        {/* Marquee CSS + swipe utilisateur */}
        <style>{`
          @keyframes partnersMarquee {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .mce-partners-viewport {
            width: 100%;
            overflow-x: auto;
            overflow-y: hidden;
            -webkit-overflow-scrolling: touch;
            touch-action: pan-x;
            scrollbar-width: none;
            -ms-overflow-style: none;
            -webkit-mask-image: linear-gradient(90deg, transparent 0, #000 6%, #000 94%, transparent 100%);
                    mask-image: linear-gradient(90deg, transparent 0, #000 6%, #000 94%, transparent 100%);
          }
          .mce-partners-viewport::-webkit-scrollbar { display: none; }

          .mce-partners-track {
            display: flex;
            gap: 1.25rem;
            width: max-content;
            /* 22 partenaires : durée allongée pour garder une vitesse de défilement confortable */
            animation: partnersMarquee 100s linear infinite;
            will-change: transform;
          }
          .mce-partners-viewport:hover .mce-partners-track,
          .mce-partners-viewport.is-interacting .mce-partners-track {
            animation-play-state: paused;
          }
          @media (prefers-reduced-motion: reduce) {
            .mce-partners-track { animation-duration: 300s; }
          }
          @media (max-width: 768px) {
            .mce-partners-track { animation-duration: 75s; }
          }
        `}</style>

        <div
          className={`relative mt-8 w-full mce-partners-viewport ${isInteracting ? 'is-interacting' : ''}`}
          onTouchStart={() => setIsInteracting(true)}
          onTouchEnd={() => setTimeout(() => setIsInteracting(false), 2500)}
          onPointerDown={(e) => { if (e.pointerType !== 'mouse') setIsInteracting(true); }}
          onPointerUp={(e) => { if (e.pointerType !== 'mouse') setTimeout(() => setIsInteracting(false), 2500); }}
        >
          <div className="mce-partners-track" aria-label="Nos partenaires">
            {[...partners, ...partners].map((p, i) => (
              <div
                key={i}
                className="shrink-0 w-[260px] md:w-[280px] bg-white rounded-2xl shadow-md hover:shadow-xl transition-all p-6 flex flex-col items-center text-center border border-slate-100"
                aria-hidden={i >= partners.length ? 'true' : 'false'}
              >
                <div className="h-28 w-full flex items-center justify-center mb-4">
                  <img
                    src={p.logo}
                    alt={p.alt}
                    className={
                      p.logoSize === 'large'
                        ? 'max-h-28 max-w-[220px] object-contain'
                        : 'max-h-20 max-w-[180px] object-contain'
                    }
                  />
                </div>

                <div
                  className="h-[2px] w-10 rounded-full mb-3"
                  style={{ backgroundColor: '#0099CC' }}
                />

                <h3
                  className="font-black text-[16px] md:text-[17px]"
                  style={{ color: '#001a3d' }}
                >
                  {p.name}
                </h3>

                {p.tagline && (
                  <p
                    className="text-[12px] font-medium mt-1 mb-2"
                    style={{ color: '#0099CC' }}
                  >
                    {p.tagline}
                  </p>
                )}

                <p
                  className={`text-[13px] leading-relaxed flex-1 ${p.tagline ? 'mt-1' : 'mt-3'} ${p.quote ? 'italic' : ''}`}
                  style={{ color: '#001a3d', opacity: 0.75 }}
                >
                  {p.desc}
                </p>

                <div className="mt-5">
                  {p.url ? (
                    <a
                      href={p.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Visiter le site de ${p.name}`}
                      className="w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110 hover:shadow-md"
                      style={{ backgroundColor: '#e6f5fb' }}
                    >
                      <ArrowRight className="w-5 h-5" style={{ color: '#0099CC' }} />
                    </a>
                  ) : (
                    <div
                      className="w-10 h-10 rounded-full flex items-center justify-center"
                      style={{ backgroundColor: '#e6f5fb' }}
                    >
                      <ArrowRight className="w-5 h-5" style={{ color: '#0099CC' }} />
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}
